(function(){
if(window.innerWidth>=750)return;
function s(el,p,v){if(el)el.style.setProperty(p,v,'important');}
function q(sel){return document.querySelector(sel);}
function qa(sel){return document.querySelectorAll(sel);}
function run(){
/* Gap header to gallery — zero */
s(q('product-info'),'padding-top','0');
s(q('product-info'),'padding-bottom','0');
var sec=q('.shopify-section.section');
if(sec)s(sec,'padding-top','0');
/* Gallery to thumbnails — tight but no black bar */
s(q('.slider.slider--mobile'),'margin-bottom','0');
/* Thumbnail slider */
s(q('.thumbnail-slider'),'margin-top','2px');
s(q('.thumbnail-list'),'padding','0');
qa('.thumbnail-list .thumbnail-list__item img, .thumbnail-list__item .global-media-settings').forEach(function(e){
s(e,'object-fit','cover');s(e,'background','transparent');
});
/* Product info blocks — tighten */
var ic=q('.product__info-container');
if(ic){for(var i=0;i<ic.children.length;i++){s(ic.children[i],'margin-top','0.25rem');s(ic.children[i],'margin-bottom','0.1rem');}
if(ic.children[0])s(ic.children[0],'margin-top','0');}
/* Title */
s(q('.product__title'),'margin-bottom','0.15rem');
/* Price */
s(q('.price__container'),'margin-bottom','0.1rem');
var pdl=q('.price dl');if(pdl){s(pdl,'margin-top','0.1rem');s(pdl,'margin-bottom','0.1rem');}
/* Swatches — especially below */
var sw=q('.rc-swatches');
if(sw){s(sw,'margin-top','0.1rem');s(sw,'margin-bottom','0.05rem');s(sw,'padding','0');}
/* Tax — FIX #3: add bottom margin for spacing before ATC */
s(q('.product__tax'),'margin-top','0');s(q('.product__tax'),'margin-bottom','4px');
/* Installment */
var inst=q('.installment');
if(inst){s(inst,'margin','0');if(inst.parentElement&&inst.parentElement.tagName==='DIV'){s(inst.parentElement,'margin-top','0');s(inst.parentElement,'margin-bottom','0');}}
/* Quantity */
var qty=q('.product-form__quantity');
if(qty){s(qty,'margin-top','0.15rem');s(qty,'margin-bottom','0.1rem');}
/* ATC form */
var pf=q('.product-form');
if(pf){s(pf,'margin-top','0.15rem');s(pf,'margin-bottom','0.15rem');if(pf.parentElement)s(pf.parentElement,'margin-top','0.1rem');}
s(q('.product-form__submit'),'margin-bottom','0.3rem');
s(q('.product-form__buttons'),'margin-top','0');
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',run);}else{run();}
})();